/* React */
import React from "react";

/* React-Redux */
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/redux/store";

/* Thunks */
import { loginWithCredentials } from "src/redux/thunks/auth/loginWithCredentialsThunk";

/* React-Hook-Form */
import { useForm } from "react-hook-form";

/* Utils */
import useCredentials from "src/utils/hooks/useCredentials";

/* Helper */
import { getLoginFormInputs } from "../getLoginFormInputs";

/* Components */
import ProviderContainer from "src/components/login/provider-container/ProviderContainer";
import FormInput from "src/components/shared/input/form-input/FormInput";
import PrimaryButton from "src/components/shared/buttons/primary-button/PrimaryButton";

/* Interfaces */
import { BaseLoginProps } from "src/shared/interfaces/api/Login";

const FirstFactor: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    register,
    formState: { errors },
    clearErrors,
    setValue,
    trigger,
    handleSubmit,
  } = useForm();

  const initialCredentials: BaseLoginProps = {
    usernameEmail: "",
    password: "",
  };

  const { credentials, handleCredentials } = useCredentials(
    {
      initialCredentials,
      setValue,
      trigger,
    }
  );

  const { usernameEmail, password } = credentials;

  const onSubmit = () => {
    dispatch(loginWithCredentials(credentials));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      {getLoginFormInputs(credentials).map(
        (input, index) => {
          return (
            <FormInput
              key={index}
              testId={input.testId}
              register={register(input.name, {
                required: input.requiredMessage,
                validate: input.validate,
              })}
              type={input.type}
              name={input.name}
              placeholder={input.placeholder}
              value={input.value}
              errors={errors}
              clearErrors={clearErrors}
              icon={input.icon}
              onChange={handleCredentials}
            />
          );
        }
      )}
      <PrimaryButton
        testId={"submit-btn"}
        type={"submit"}
        ariaLabel={"Login"}
        label={"Login"}
        disabled={
          usernameEmail.length === 0 &&
          password.length === 0
        }
      />
      <ProviderContainer />
    </form>
  );
};

export default FirstFactor;
